// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3C-mh","content":"styles_content__3Qgmg","selectAll":"styles_selectAll__aodnv"};